import React, { Component } from 'react';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import { SanitizedInnerHTML } from 'src/common';
import InfoIcon from 'material-ui/svg-icons/action/info-outline';

export default class CustomTooltip extends Component {
    render() {
        const { id, children, iconClassName, tooltipClassName, place, text, stopPropagation, style } = this.props;

        if (!id) console.warn('CustomTooltip should have an id');

        return (
            <>
                <span
                    className={`custom-tooltip ${tooltipClassName || ''}`}
                    data-tooltip-id={id}
                    onClick={event => {
                        if (stopPropagation) event.stopPropagation();
                    }}
                    style={{ ...style, cursor: 'pointer' }}>
                    {children || <InfoIcon className="custom-tooltip-icon" color="#337ab7" />}
                </span>

                <Tooltip id={id} place={place || 'top'} variant="light" opacity={1} openOnClick={true}>
                    {text.type ? text : <SanitizedInnerHTML html={text} />}
                </Tooltip>
            </>
        );
    }
}
